<template>
  <div class="select-form">
    <h2 class="label" v-if="label">
      {{ label }}
    </h2>
    <b-dropdown
      aria-role="list"
      :mobile-modal="false"
      v-model="selectedOption"
      @change.once="$emit('change')"
      @input="$emit('change-data', selectedOption)"
    >
      <button class="select-button" slot="trigger" @input="$emit('input')">
        {{ selectedOption.value }}
      </button>

      <b-dropdown-item
        aria-role="listitem"
        v-for="item in data"
        :value="item"
        :key="item.id"
      >
        {{ item.value }}
      </b-dropdown-item>
    </b-dropdown>
  </div>
</template>

<script>
export default {
  data() {
    return {
      selectedOption: { value: this.$t('placeholders.dropdown') }
    }
  },
  props: {
    label: {
      type: String,
      default: ''
    },
    data: {
      type: Array,
      default: () => {
        return []
      }
    },
    value: {
      type: [Object, String],
      default: () => {
        return {}
      }
    }
  },
  watch: {
    value: {
      immediate: true,
      handler: function (newValue) {
        this.selectedOption.value = newValue
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import '~@/assets/stylesheets/styleguide';
@import '~@/assets/stylesheets/forms';

.dropdown .dropdown-trigger {
  &:before {
    height: calc(100% - 0.7rem);
  }
  button.select-button {
    overflow: hidden;
    height: unset;
    min-height: 2.5rem;
    padding: 0.5rem 3.5rem 0.5rem 1rem;
    &:after {
      content: '';
      position: absolute;
      right: 1px;
      width: 3.4rem;
      top: 0.375rem;
      height: 1.8rem;
      height: calc(100% - 0.7rem);
    }
  }
}
</style>
